<template lang="pug">
.idea-card.column(@dragstart="$emit('dragstart', $event)" @click="$emit('click', $event)")
  .badge(:class="data.status") {{ t[data.status] || data.status }}
  .title {{ data.title }}
  .publication-date.row.center.left(v-if="linked_post || data.publication_date")
    .icon
      svg-icon(name="calendar")
    .column(v-if="linked_post")
      div {{ t.publication_date }}
      .date {{  new Date(linked_post.date).format('%d %b %Y', $root.lang) }}
    .column(v-else)
      div {{ t.wanted_publication_date }}
      .date {{  new Date(data.publication_date).format('%d %b %Y', $root.lang) }}
</template>
<script>
export default {
  props: ['data', 'calendar_id'],
  data() {
    return {
      linked_post: null,
    }
  },
  watch:{
    'data.post_id': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return
        if (!newVal || !this.calendar_id) return
        bind_key(this, 'linked_post', `public/posts/${this.calendar_id}/${newVal}`)
      },
      immediate: true,
    },
  },
}
</script>
<style>
.idea-card {
  background: white;
  border-radius: var(--box-radius);
  padding: 16px;
  min-height: fit-content;
}
.idea-card:hover {
  background: var(--background);
  cursor: pointer;
}
.idea-card .title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 8px;
}
.idea-card .badge {
  margin-bottom: 4px;
}
.idea-card .publication-date {
  color: var(--darkgrey);
  fill: var(--darkgrey);
  font-size: 11px;
  font-weight: light;
  line-height: 1;
}
.idea-card .publication-date .date {
  font-weight: bold;
}
.idea-card .publication-date .icon {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}



</style>
